module.exports = __webpack_public_path__ + "img/50d.b80ea996.svg";